<template>
    <tailwind-layout title="Create Card">
        <div class="py-8">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-rent-risk-blue-100 overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="bg-rent-risk-blue-100 pt-8 pb-16 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-8">
                        <div class="relative max-w-xl mx-auto">
                            <svg class="absolute left-full transform translate-x-1/2" width="404" height="404" fill="none" viewBox="0 0 404 404" aria-hidden="true">
                                <defs>
                                    <pattern id="85737c0e-0916-41d7-917f-596dc7edfa27" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                        <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                                    </pattern>
                                </defs>
                                <rect width="404" height="404" fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)" />
                            </svg>
                            <svg class="absolute right-full bottom-0 transform -translate-x-1/2" width="404" height="404" fill="none" viewBox="0 0 404 404" aria-hidden="true">
                                <defs>
                                    <pattern id="85737c0e-0916-41d7-917f-596dc7edfa27" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                        <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                                    </pattern>
                                </defs>
                                <rect width="404" height="404" fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)" />
                            </svg>
                            <div class="text-center">
                                <h2 class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                    Payment Failed
                                </h2>
                            </div>
                            <div class="mt-12">
                                <p class="text-red-700 mb-4 text-center text-xl">
                                    Payment for your application has failed. Please contact your agent to verify their card information, then revisit this page.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import FormButton from '@/Shared/FormButton.vue'

export default {
    props: {
        application: Object,
    },
    components: {
        TailwindLayout,
        FormButton,
    },

    methods: {
    }
}
</script>
